var map = {
	"./i3.png": "MjLz",
	"./i3en.png": "d4zP"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "iARg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/article/iosMessageSet ^\.\/i3.*\.png$
// module id = iARg
// module chunks = 0